import { render } from "./SystemErrors.vue?vue&type=template&id=b45a3814"
import script from "./SystemErrors.vue?vue&type=script&lang=js"
export * from "./SystemErrors.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__